/**
 * Shared hook for status toggle filter logic used by feedback pages.
 */

const STATUS_OPTIONS = [
  { value: 'pending', label: 'New' },
  { value: 'in_review', label: 'In Review' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' }
]

const DEFAULT_STATUSES = ['in_review', 'pending']

/**
 * Compare two status arrays for set equality (order-independent).
 */
function statusSetsEqual(a, b) {
  if (!a && !b) return true
  if (!a || !b) return false
  if (a.length !== b.length) return false
  const sorted1 = [...a].sort()
  const sorted2 = [...b].sort()
  return sorted1.every((v, i) => v === sorted2[i])
}

const useStatusFilter = (filters, setFilters) => {
  const handleStatusToggle = (statusValue) => {
    const currentStatuses = Array.isArray(filters.status) ? filters.status : []
    let newStatuses
    if (currentStatuses.includes(statusValue)) {
      newStatuses = currentStatuses.filter((s) => s !== statusValue)
    } else {
      newStatuses = [...currentStatuses, statusValue]
    }
    setFilters({ status: newStatuses.length > 0 ? newStatuses : null })
  }

  const isStatusActive = (statusValue) => {
    if (!filters.status) return false
    return Array.isArray(filters.status) && filters.status.includes(statusValue)
  }

  const isShowingAll =
    !filters.status || (Array.isArray(filters.status) && filters.status.length === 0)

  const hasActiveFilters =
    filters.category || (filters.status && !statusSetsEqual(filters.status, DEFAULT_STATUSES))

  return {
    STATUS_OPTIONS,
    handleStatusToggle,
    isStatusActive,
    isShowingAll,
    hasActiveFilters
  }
}

export default useStatusFilter
